import { render, staticRenderFns } from "./GiftATreeBargain.vue?vue&type=template&id=2051667b&"
import script from "./GiftATreeBargain.vue?vue&type=script&lang=ts&"
export * from "./GiftATreeBargain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports